import { Component, OnInit } from '@angular/core';
import { SlideInOutAnimation } from 'src/app/_animations/animations';

@Component({
  selector: 'app-alert-notification',
  templateUrl: './alert-notification.component.html',
  styleUrls: ['./alert-notification.component.scss'],
  animations: [SlideInOutAnimation]
})
export class AlertNotificationComponent implements OnInit {
  toggler: boolean = false;
  animationState: string;
  
  constructor() { 
    this.animationState = localStorage.getItem('animationState') || 'in'; // retrieve from local storage
    // this.toggleShowDiv('divA');
    if(this.animationState == 'in')
      this.toggler = true;
  }
  
  toggleShowDiv(divName: string) {
    if (divName === 'divA') {
      this.animationState = this.animationState === 'out' ? 'in' : 'out';
      localStorage.setItem('animationState', this.animationState); // store in local storage
    }
  }
  
  ngOnInit() {
  }

}
